// extracted by mini-css-extract-plugin
module.exports = {"content":"MyInfo_content__3MjaI","header":"MyInfo_header__1tHwk"};